module.exports = __webpack_public_path__ + "img/second-section-2.6b718248.jpg";